import { forwardRef } from 'react'
import clsx from 'clsx'
import { HugeiconsIcon, HugeiconsIconProps } from '@hugeicons/react'

interface Props {
  label: string
  disabled?: boolean
  Icon: HugeiconsIconProps['icon']
  onClick?: () => void
  active?: boolean
}

const ToolbarButton = forwardRef<HTMLButtonElement, Props>(
  function ToolbarButton(props, forwardRef) {
    const { disabled, label, Icon, active, onClick } = props

    return (
      <button
        disabled={disabled}
        type="button"
        onClick={onClick}
        ref={forwardRef}
        className={clsx(
          'cursor-pointer rounded-[5px] p-1 text-text hover:bg-primary-bright disabled:pointer-events-none disabled:opacity-50',
          active && 'bg-primary text-white hover:bg-primary-dark'
        )}
        aria-label={label}
        tabIndex={0}
      >
        <HugeiconsIcon icon={Icon} className="size-5" />
      </button>
    )
  }
)

export default ToolbarButton
